"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeERC20__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var SafeERC20__factory_1 = require("./SafeERC20__factory");
Object.defineProperty(exports, "SafeERC20__factory", { enumerable: true, get: function () { return SafeERC20__factory_1.SafeERC20__factory; } });
